import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import Modal from 'components/modal'
import ContactUsModal from './contact-us-modal'
import { CONTACT_US_MODAL } from 'constants/modal-constants'
import { hideModal } from 'actions/common'
import { getCurrentModal } from 'selectors/common'
import { getMarket } from 'selectors/entities'
import { getCurrentPartner } from 'selectors/settings'

class ContactUsModalContainer extends Component {

  render() {
    const isOpen = this.props.currentModal === CONTACT_US_MODAL

    return (
      <Modal closeModal={this.props.hideModal} isOpen={isOpen} title="Contact Us">
        <ContactUsModal market={this.props.market} />
      </Modal>
    )
  }
}

ContactUsModalContainer.propTypes = {
  currentModal: PropTypes.string,
  hideModal: PropTypes.func,
  market: PropTypes.object,
}

const mapStateToProps = state => {
  const partner = getCurrentPartner(state)
  const market = partner ? getMarket(partner.market)(state) : null

  return {
    currentModal: getCurrentModal(state),
    market,
  }
}

const mapDispatchToProps = { hideModal }

export default connect(mapStateToProps, mapDispatchToProps)(ContactUsModalContainer)



/** WEBPACK FOOTER **
 ** ./src/components/contact-us-modal/contact-us-modal-container.js
 **/